import { Field, Model } from 'serialize-ts';

@Model()
export class Price {
  @Field()
  amount: number;

  @Field()
  currency: string;

  @Field()
  vatValue: number;

  @Field()
  unit: string;

  @Field()
  grossPrice: number;

  @Field()
  netPrice: number;
}
